import { createSurveyStyles } from '@sm/webassets';
import { ThemeShape } from '~app/sharedTypes';

const useSurveyStyles = createSurveyStyles((theme: ThemeShape) => ({
  pageDescription: {
    color: theme.questionColor,
    lineHeight: 1.25,
    ...theme?.questionTitle,
    // reset font weight changed by the theme above
    '& strong': {
      fontWeight: 'bold !important',
    },
  },
}));

export default useSurveyStyles;
